var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewsFeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1875 4.71875V4.01562C21.1875 2.85252 20.2412 1.90625 19.0781 1.90625H2.10938C0.946266 1.90625 0 2.85252 0 4.01562V19.5781C0 21.5166 1.57711 23.0938 3.51562 23.0938H20.4844C22.4229 23.0938 24 21.5166 24 19.5781V4.71875H21.1875ZM19.7812 4.01562V4.71875H5.625V18.875H4.21875V4.01562C4.21875 3.76916 4.17586 3.53258 4.09781 3.3125H19.0781C19.4658 3.3125 19.7812 3.62792 19.7812 4.01562ZM1.40625 19.5781V4.01562C1.40625 3.62792 1.72167 3.3125 2.10938 3.3125C2.49708 3.3125 2.8125 3.62792 2.8125 4.01562V20.2812H5.50406C5.21381 21.0996 4.43227 21.6875 3.51562 21.6875C2.35252 21.6875 1.40625 20.7412 1.40625 19.5781ZM22.5938 19.5781C22.5938 20.7412 21.6475 21.6875 20.4844 21.6875H6.3262C6.76861 21.0995 7.03125 20.369 7.03125 19.5781V6.125H22.5938V19.5781Z",
    fill: "#737373"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4375 7.53125H21.1875V8.9375H8.4375V7.53125Z",
    fill: "#737373"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6562 10.3438H21.1875V11.75H12.6562V10.3438Z",
    fill: "#737373"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4375 10.3438H11.25V11.75H8.4375V10.3438Z",
    fill: "#737373"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4375 18.7812H18.375V20.1875H8.4375V18.7812Z",
    fill: "#737373"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4375 17.375H21.1875V13.1562H8.4375V17.375ZM9.84375 14.5625H19.7812V15.9688H9.84375V14.5625Z",
    fill: "#737373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsFeed);
export default __webpack_public_path__ + "static/media/News_Feed.9279316b62b5e0085640cbefaae180d0.svg";
export { ForwardRef as ReactComponent };